export const QUOTA_FORM_HIERARCHY_KEYS = {
  trendId: 'trendId',
  purchasingGroupId: 'purchasingGroupId',
  commodityGroupId: 'commodityGroupId',
  categoryId: 'categoryId',
  subcategoryId: 'subcategoryId'
}
